import React, { useEffect, useState } from 'react';

import { useForm } from 'react-hook-form';

import { Modal } from 'react-bootstrap';

import { toast } from '@rickylandino/react-messages';

import { insertCategory } from '../../common/services/MaintenanceService';

export default function CategoryModal(props) {
    const { register, handleSubmit, setValue, getValues,
        formState: { errors }, control } = useForm();

    const [modalInfo, setModalInfo] = useState({
        showModal: false,
        categoryItem: {
            category: '',
            inactiveYN: false
        }
    });

    useEffect(() => {
        setModalInfo({
            ...modalInfo,
            showModal: true
        });
    }, []);

    function closeModal() {

        setModalInfo({
            showModal: false,
            categoryItem: {
                category: '',
                inactiveYN: false
            }
        });
    }

    function handleUpdate() {
        var item = modalInfo.categoryItem;

        item.inactiveYN = getValues().inactiveYN ? 1 : 0;
        item.category = getValues().category;

        insertCategory(item).then(data => {
            toast.success("Category Added");

            if (props.from === 'manageFacility') {
                item.categoryID = data;
                setTimeout(() => {
                    props.hideModal(item);
                }, 1000);
            }

            closeModal();
        })
    }

    return (
        <Modal size='lg' show={modalInfo.showModal} backdrop='static' onHide={closeModal}>
            <Modal.Header>
                <h1>Category</h1>
            </Modal.Header>
            <Modal.Body>
                <div className="panel-content">
                    <div className="row">
                        <div className="form-group col-12">
                            <label className="form-label">Category Name</label>
                            <input className="form-control-custom" {...register("category")} />
                        </div>

                        <div className="form-group col-12">
                            <label className="form-label">Set Inactive</label>
                            <div className="form-control-custom no-border">
                                <div className="custom-control custom-checkbox custom-control-inline">
                                    <input type="checkbox" className="custom-control-input" {...register("inactiveYN")} />
                                    <label className="custom-control-label"></label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <div className="row">
                    <div className="form-group col-12 padding-25-10">
                        <button className="btn btn-submit" onClick={handleUpdate}>Save</button>
                        <button className="btn btn-outline-default margin-left-15" id="closeModal" onClick={closeModal}>Cancel</button>
                    </div>
                </div>
            </Modal.Footer>
        </Modal>
    );
}